'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = simboxEditable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _utils = require('base-contentmodel/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function transformElement(props, fn) {
  var changes = {};
  if ((0, _typeof3.default)(props.children) === 'object') {
    var children = _react.Children.toArray(props.children);
    var transformedChildren = children.map(fn);
    changes.children = transformedChildren;
  }

  return changes;
}

function finalizeElement(element, editorViewStore) {
  var addedChanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var dataEditableTransfer = arguments[3];
  var noChildren = arguments[4];

  var changes = transformElement(element.props, function (element) {
    return noChildren ? element : transform(element, editorViewStore, dataEditableTransfer);
  });

  if (addedChanges.children) {
    changes.children = changes.children && changes.children.length ? changes.children.concat(addedChanges.children) : addedChanges.children;
    delete addedChanges.children;
  }

  (0, _assign2.default)(changes, addedChanges);

  return (0, _keys2.default)(changes).length === 0 ? element : (0, _react.cloneElement)(element, changes, changes.children || element.props.children);
}

// this opens the editor's context menu by adding items to its menu
var openContextMenu = (0, _mobx.action)(function (e, menuItems, editorViewStore) {
  editorViewStore.closeMenu();
  var location = { x: e.pageX, y: e.pageY };
  setTimeout(function () {
    return editorViewStore.openMenu(location, menuItems);
  }, 10);
});

function transform(element, editorViewStore, dataEditableTransfer) {
  // return text elements
  if ((typeof element === 'undefined' ? 'undefined' : (0, _typeof3.default)(element)) !== 'object') return element;

  var checkParentArray = false;
  var dataEditable = void 0;
  var initParams = {};
  var hideInMenu = void 0;
  var noChildren = void 0;

  var isReactElement = typeof element.type === "function";

  // is a react element and needs to pass items down to their child dom elements to break the inheritence barrier
  if (isReactElement) {
    return finalizeElement(element, editorViewStore, {
      // "data-editable": element.props["data-editable"], 
      "data-editable-transfer": dataEditableTransfer || element.props["data-editable-transfer"],
      "data-editable-key": element.key // needed for array stuff
    });
  }

  var elementSuppliedDataEditable = element.dataset ? element.dataset.dataEditable : element.props["data-editable"];
  var dataEditableKey = element.props["data-editable-key"];
  dataEditableTransfer = element.props["data-editable-transfer"] || dataEditableTransfer;

  if (!dataEditableTransfer && typeof elementSuppliedDataEditable === "string") {
    throw new Error("cannot initiate data-editable with string, supply contentmodel earlier in the chain");
  } else if (dataEditableTransfer && typeof elementSuppliedDataEditable === "string") {
    // simple inherit mode
    // data-editable={"accessorTo..."}
    // transform to:
    // data-editable={[parentContentModel, "accessorTo..."]}
    dataEditable = [dataEditableTransfer, elementSuppliedDataEditable];
  } else if (elementSuppliedDataEditable) {
    // element's direct "data-editable", override inherited from transform
    if ((0, _typeof3.default)(element.props.children) !== 'object') {
      console.warn("do not place 'editable' on this element, it must have children (no inputs etc)");
      return element;
    }
    dataEditable = elementSuppliedDataEditable;
    // if(dataEditable 
    //   && Array.isArray( dataEditable ) 
    //   && ( dataEditable.length === 2 || dataEditable.length === 3 ) ) debugger
  } else if (dataEditableTransfer && Array.isArray(dataEditableTransfer) && (dataEditableTransfer.length === 2 || dataEditableTransfer.length === 3)) {
    // then dataEditable inherited via transform
    // since this dataEditable has been inherited, will want to check against it
    checkParentArray = true;
    dataEditable = dataEditableTransfer;
  } else if (dataEditableTransfer) {
    // passed via transform also, but no valid parent to check against... keep going
    return finalizeElement(element, editorViewStore, {}, dataEditableTransfer);
  } else if (!dataEditableTransfer) {
    // no data-editable supplied yet, traverse children until we find one
    return finalizeElement(element, editorViewStore);
  }

  // grab some init params if supplied (basic object as 3rd data-editable param)
  if ((0, _typeof3.default)(dataEditable[2]) === "object" && dataEditable[2].constructor.name !== "ObservableArray") {
    initParams = dataEditable.splice(2, 1)[0];
    if (initParams.hideInMenu) {
      hideInMenu = Array.isArray(initParams.hideInMenu) ? initParams.hideInMenu : [initParams.hideInMenu];
      delete initParams.hideInMenu;
    }
    if (initParams.noChildren) {
      noChildren = true;
      delete initParams.noChildren;
    }
  }

  if (dataEditable.length === 3 && dataEditable[2] !== undefined) {
    //not supported yet, so take it down a notch...
    // transform to:
    // data-editable={[parentContentModel, "accessorTo..."]}
    dataEditable = [dataEditable[0][dataEditable[1]], dataEditable[2]];
  }

  var changes = {};
  var editableIcons = [];
  var menuItems = void 0;
  var contentModel = void 0;
  var cmAccessorMode = void 0;

  // at this point dataEditable is either an object or an array. string never makes it!
  switch (dataEditable.length) {
    case undefined:
    case 1:
      // direct mode
      // data-editable={contentModel}
      // one model -> pencil -> directly opens in editor

      // just in case it looks like... data-editable={[contentModel]} check for array
      contentModel = Array.isArray(dataEditable) ? dataEditable[0] : dataEditable;
      changes.className = element.props.className ? element.props.className + " editable" : "editable";

      var handleClick = function handleClick(e) {
        return editorViewStore.startEditing({
          contentModel: contentModel
          // onSave: () => editorViewStore.stopEditing()
        });
      };

      editableIcons.push(_react2.default.createElement('span', {
        key: 'editIcon',
        className: 'editable-icon',
        onClick: handleClick }));
      break;

    case 2:
      contentModel = dataEditable[0];
      if (!(contentModel instanceof _baseContentmodel2.default)) {
        console.warn("not an editable contentModel!" + contentModel);
        return element;
      }
      if (!contentModel.slots) throw new Error("missing slot definition: " + accessor + contentModel.constructor.name);
      var accessor = dataEditable[1];
      var actual = contentModel[accessor];
      // if( actual == null ) throw new Error("property does not refer to an editable contentmodel or array: "+accessor)
      if (!contentModel.slots.hasOwnProperty(accessor)) throw new Error("accessor refers to non-contentmodel");
      var slot = contentModel.slots[accessor];

      var ItemContentModels = [];
      if (Array.isArray(slot)) {
        for (var i in slot) {
          var ItemContentModel = slot[i];
          if (!(0, _utils.checkInstanceOf)(ItemContentModel.prototype, _baseContentmodel2.default.prototype)) {
            console.warn("ItemContentModel " + ItemContentModel.prototype + " accessor refers to non-contentmodel! not supported yet.");
            continue;
          }

          // add all types that inherit from ItemContentModel
          for (var j in window.application.contentModel.types) {
            var SubItemContentModel = window.application.contentModel.types[j];
            if ((0, _utils.checkInstanceOf)(SubItemContentModel.prototype, ItemContentModel.prototype)) {
              ItemContentModels.push(SubItemContentModel);
            }
          }
        }
      } else {
        var _ItemContentModel = slot;
        if ((0, _utils.checkInstanceOf)(_ItemContentModel.prototype, _baseContentmodel2.default.prototype)) {
          // add all types that inherit from ItemContentModel
          for (var _j in window.application.contentModel.types) {
            var _SubItemContentModel = window.application.contentModel.types[_j];
            if ((0, _utils.checkInstanceOf)(_SubItemContentModel.prototype, _ItemContentModel.prototype)) {
              ItemContentModels.push(_SubItemContentModel);
            }
          }
        } else {
          console.warn("ItemContentModel " + _ItemContentModel.prototype + " accessor refers to non-contentmodel! not supported yet.");
        }
      }

      ItemContentModels = ItemContentModels.filter(function (cm, i) {
        return ItemContentModels.indexOf(cm) == i;
      });

      var actualIsArray = actual && (Array.isArray(actual) || actual.constructor && actual.constructor.name === "ObservableArray");
      cmAccessorMode = !actualIsArray;
      var arrayAccessorMode = actualIsArray && !checkParentArray;
      var arrayChildAccessorMode = actualIsArray && checkParentArray;

      // now we will define the menu items and editable icons for all the permutations
      var isReadOnly = contentModel.meta && contentModel.meta[accessor] && contentModel.meta[accessor].readonly;

      if (isReadOnly) {
        //do nothing
      } else if (cmAccessorMode) {
        // parentCm mode:
        // data-editable={[contentModel, "accessorToCM"]}
        // on sub-model -> pencil -> context menu -> edit, replace with existing, replace with new

        if (element.type !== "div" && element.type !== "p" && (0, _typeof3.default)(element.props.children) !== 'object') {
          console.warn("do not place 'editable' on this element, it must have children (no inputs etc)");
          return element;
        }

        changes.className = element.props.className ? element.props.className + " editable" : "editable";

        // make it a computed and re-get contentModel, so it updates properly after replace
        menuItems = (0, _mobx.computed)(function () {
          // naughty. updating state inside a computed!
          var actual = contentModel[accessor];

          var handleCreate = function handleCreate(e) {
            var ItemContentModel = ItemContentModels[e.target.value];
            var num = getRandomIntInclusive(0, 1000);
            var item = new ItemContentModel((0, _extends3.default)({
              id: ItemContentModel.name.replace("ContentModel", "") + "_" + num
            }, initParams));
            editorViewStore.startEditing({
              contentModel: item,
              onSave: function onSave() {
                // add item back to parent after having saved it
                contentModel.updateValue(accessor, item);
                contentModel.saveEntity(function () {
                  return initParams && initParams.onSave && initParams.onSave(contentModel, item);
                });
                // editorViewStore.stopEditing();
              }
            }, contentModel);
          };

          var handleReplace = function handleReplace(e) {
            var replacer = contentModel.$parent.entities.get(e.target.value);
            contentModel.updateValue(accessor, replacer);
            if (!initParams || !initParams.insideEditor) contentModel.saveEntity(function () {
              return initParams && initParams.onSave && initParams.onSave(contentModel, replacer);
            });
            editorViewStore.closeMenu();
          };

          var handleEdit = function handleEdit(e) {
            editorViewStore.startEditing({
              contentModel: actual
              // onSave: () => editorViewStore.stopEditing()
            }, contentModel);
            editorViewStore.closeMenu();
          };

          var handleRemove = function handleRemove(e) {
            contentModel.updateValue(accessor, null);
            if (!initParams || !initParams.insideEditor) contentModel.saveEntity(function () {
              return initParams && initParams.onSave && initParams.onSave(contentModel, replacer);
            });
            editorViewStore.closeMenu();
          };

          var filteredEnts = [];

          if (contentModel._options && contentModel._options.hasOwnProperty(accessor)) {
            filteredEnts = contentModel._options[accessor];
          } else {
            for (var _i in ItemContentModels) {
              filteredEnts = filteredEnts.concat(ItemContentModels[_i].allEntities());
            }
          }

          filteredEnts = filteredEnts.filter(function (cm) {
            return cm !== actual && cm.isAvailable && cm.id && cm.uniqueDisplayName;
          }).sort(function (a, b) {
            if (a.uniqueDisplayName.toLowerCase() < b.uniqueDisplayName.toLowerCase()) return -1;
            if (a.uniqueDisplayName.toLowerCase() > b.uniqueDisplayName.toLowerCase()) return 1;
            return 0;
          });

          var items = {
            create: _react2.default.createElement(
              'div',
              { key: 'create' },
              'Add new: ',
              _react2.default.createElement(
                'select',
                { onChange: handleCreate },
                _react2.default.createElement('option', null),
                (0, _keys2.default)(ItemContentModels).map(function (i) {
                  return _react2.default.createElement(
                    'option',
                    { key: i, value: i },
                    ItemContentModels[i].name
                  );
                })
              )
            ),
            edit: actual ? _react2.default.createElement(
              'span',
              { key: 'edit', onClick: handleEdit },
              'Edit ',
              actual.uniqueDisplayName
            ) : false,
            replace: _react2.default.createElement(
              'div',
              { key: 'replace' },
              actual == null ? 'Add' : 'Replace with',
              ': ',
              _react2.default.createElement(
                'select',
                { value: actual && actual.id, onChange: handleReplace },
                _react2.default.createElement('option', null),
                filteredEnts.map(function (cm) {
                  return _react2.default.createElement(
                    'option',
                    { key: cm.id, value: cm.id },
                    cm.uniqueDisplayName
                  );
                })
              )
            ),
            remove: _react2.default.createElement(
              'span',
              { key: 'remove', onClick: handleRemove },
              'Remove ',
              actual && actual.uniqueDisplayName
            )
          };
          var allReadOnly = true;
          for (var _i2 in ItemContentModels) {
            allReadOnly = allReadOnly && (ItemContentModels[_i2] === _baseContentmodel2.default || ItemContentModels[_i2].readonly);
          }
          if (!filteredEnts.length) delete items.replace;
          if (allReadOnly || actual != null && actual.readonly) delete items.create;
          if (actual == null || editorViewStore.contentModel === actual || editorViewStore.lastCm && editorViewStore.lastCm.length && editorViewStore.lastCm[0] && editorViewStore.lastCm[0] === actual || actual.readonly) delete items.edit && delete items.remove;
          if (hideInMenu) hideInMenu.forEach(function (k) {
            return delete items[k];
          });
          return items;
        });

        editableIcons.push(_react2.default.createElement('span', {
          key: 'editIcon',
          className: 'editable-icon',
          onClick: function onClick(e) {
            openContextMenu(e, menuItems, editorViewStore);
          } }));
      } else if (arrayAccessorMode) {
        // parentArray mode:
        // data-editable={[contentModel, "accessorToArray"]}
        // on array items -> pencil -> context menu -> edit, replace, create new, move up, move down

        // here we setup the parentArray
        // is a content model's property, and is an array

        // @TODO support array of strings and non-contentmodels
        changes.className = element.props.className ? element.props.className + " editable array" : "editable array";

        var handleExisting = function handleExisting(e) {
          var item = contentModel.$parent.entities.get(e.target.value);
          actual.indexOf(item) === -1 && actual.push(item);
          if (!initParams || !initParams.insideEditor) contentModel.saveEntity(function () {
            return initParams && initParams.onSave && initParams.onSave(contentModel);
          });
          editorViewStore.closeMenu();
        };

        var handleCreate = function handleCreate(e) {
          var ItemContentModel = ItemContentModels[e.target.value];
          var num = getRandomIntInclusive(0, 1000);
          var item = new ItemContentModel((0, _extends3.default)({
            id: ItemContentModel.name.replace("ContentModel", "") + "_" + num
          }, initParams));
          editorViewStore.startEditing({
            contentModel: item,
            onSave: function onSave() {
              actual.indexOf(item) === -1 && actual.push(item);
              contentModel.saveEntity(function () {
                return initParams && initParams.onSave && initParams.onSave(contentModel, item);
              });
              // editorViewStore.stopEditing();
            }
          }, contentModel);
        };

        var handleEdit = function handleEdit(e) {
          return editorViewStore.startEditing({
            contentModel: contentModel
            // onSave: () => editorViewStore.stopEditing()
          }, contentModel);
        };

        menuItems = (0, _mobx.computed)(function () {
          var filteredEnts = [];

          if (contentModel._options && contentModel._options.hasOwnProperty(accessor)) {
            filteredEnts = contentModel._options[accessor];
          } else {
            for (var _i3 in ItemContentModels) {
              filteredEnts = filteredEnts.concat(ItemContentModels[_i3].allEntities());
            }
          }

          filteredEnts = filteredEnts.filter(function (cm) {
            return cm.isAvailable && !actual.some(function (item) {
              return item === cm;
            }) && cm.id && cm.uniqueDisplayName;
          }).sort(function (a, b) {
            if (a.uniqueDisplayName.toLowerCase() < b.uniqueDisplayName.toLowerCase()) return -1;
            if (a.uniqueDisplayName.toLowerCase() > b.uniqueDisplayName.toLowerCase()) return 1;
            return 0;
          });

          var items = {
            create: _react2.default.createElement(
              'div',
              { key: 'create' },
              'Add new: ',
              _react2.default.createElement(
                'select',
                { onChange: handleCreate },
                _react2.default.createElement('option', null),
                (0, _keys2.default)(ItemContentModels).map(function (i) {
                  return _react2.default.createElement(
                    'option',
                    { key: i, value: i },
                    ItemContentModels[i].name
                  );
                })
              )
            ),
            existing: _react2.default.createElement(
              'div',
              { key: 'existing' },
              'Add existing: ',
              _react2.default.createElement(
                'select',
                { onChange: handleExisting },
                _react2.default.createElement('option', null),
                filteredEnts.map(function (cm) {
                  return _react2.default.createElement(
                    'option',
                    { key: cm.id, value: cm.id },
                    cm.uniqueDisplayName
                  );
                })
              )
            ),
            edit: _react2.default.createElement(
              'span',
              { key: 'edit', onClick: handleEdit },
              'Edit ',
              contentModel.uniqueDisplayName
            )
          };
          var allReadOnly = true;
          for (var _i4 in ItemContentModels) {
            allReadOnly = allReadOnly && (ItemContentModels[_i4] === _baseContentmodel2.default || ItemContentModels[_i4].readonly || ItemContentModels[_i4].Synthetic);
          }
          if (allReadOnly) delete items.create;
          if (!filteredEnts.length) delete items.existing;
          if (editorViewStore.contentModel === contentModel || editorViewStore.lastCm && editorViewStore.lastCm.length && editorViewStore.lastCm[0] && editorViewStore.lastCm[0] === contentModel || contentModel.readonly) delete items.edit;
          if (hideInMenu) hideInMenu.forEach(function (k) {
            return delete items[k];
          });
          return items;
        });

        editableIcons.push(_react2.default.createElement(
          'button',
          { key: 'addIcon', className: 'btn green add-b', onClick: function onClick(e) {
              return openContextMenu(e, menuItems, editorViewStore);
            } },
          'Add'
        ));
      } else if (arrayChildAccessorMode) {
        // @TODO a more specific way to check if inside iterator than if element.key is preset?
        // parentArray mode, child model:          
        // is simply contentmodel, but parent is a direct array
        // NOTE: when iterating through submodels, each will have its key checked against the last inherited data-editable parent
        // if the parent array contains a contentmodel with an id that matches the array item key, 
        // then the array item methods will be added to it (edit, replace, new, up, down)
        // For ex: {items.map( (item, index) => <div key={item.id}></div> )}
        // *so make sure the key === item.id*
        // identical items cannot exist in a contentmodel array that will have array editable features
        var parentArray = actual;
        var parentCm = contentModel;
        var key = element.key || dataEditableKey;

        // match key against parent array item ids
        var contentModelIndex = key ? parentArray.findIndex(function (cm) {
          return !!key.match("\\$" + cm.id + "$");
        }) : -1;
        // if (contentModelIndex === -1 && key && key.length > 2 ) debugger
        if (contentModelIndex > -1) {
          if ((0, _typeof3.default)(element.props.children) !== 'object') {
            console.warn("do not place 'editable' on this element, it must have children (no inputs etc)");
            return element;
          }

          changes.className = element.props.className ? element.props.className + " editable array-child" : "editable array-child";

          // make it a computed and re-get contentModel, so it updates properly after replace
          menuItems = (0, _mobx.computed)(function () {
            // naughty. updating state inside a computed!
            if (!parentArray.length) return false;
            if (contentModelIndex === parentArray.length) contentModelIndex--;
            var contentModel = parentArray[contentModelIndex];
            var handleRemove = function handleRemove(e) {
              parentArray.remove(contentModel);
              if (!initParams || !initParams.insideEditor) parentCm.saveEntity();
              editorViewStore.closeMenu();
            };

            var handleReplace = function handleReplace(e) {
              var replacer = contentModel.$parent.entities.get(e.target.value);
              parentArray.splice(contentModelIndex, 1, replacer);
              if (!initParams || !initParams.insideEditor) parentCm.saveEntity();
              editorViewStore.closeMenu();
            };

            var handleMoveUp = function handleMoveUp(e) {
              return (0, _mobx.runInAction)(function () {
                if (contentModelIndex !== 0) {
                  parentArray.splice(contentModelIndex - 1, 0, parentArray.splice(contentModelIndex, 1)[0]);
                  contentModelIndex--;
                  if (!initParams || !initParams.insideEditor) parentCm.saveEntity();
                  editorViewStore.closeMenu();
                }
              });
            };

            var handleMoveDown = function handleMoveDown(e) {
              return (0, _mobx.runInAction)(function () {
                if (contentModelIndex !== parentArray.length - 1) {
                  parentArray.splice(contentModelIndex + 1, 0, parentArray.splice(contentModelIndex, 1)[0]);
                  contentModelIndex++;
                  if (!initParams || !initParams.insideEditor) parentCm.saveEntity();
                  editorViewStore.closeMenu();
                }
              });
            };

            var handleEdit = function handleEdit(e) {
              editorViewStore.startEditing({
                contentModel: contentModel
                // onSave: () => editorViewStore.stopEditing()
              }, parentCm);
              editorViewStore.closeMenu();
            };

            var filteredEnts = (contentModel._options && contentModel._options.hasOwnProperty(accessor) ? contentModel._options[accessor] : contentModel.allOfSameType).filter(function (cm) {
              return cm.isAvailable && !parentArray.some(function (item) {
                return item === cm;
              }) && cm.id && cm.uniqueDisplayName;
            }).sort(function (a, b) {
              if (a.uniqueDisplayName.toLowerCase() < b.uniqueDisplayName.toLowerCase()) return -1;
              if (a.uniqueDisplayName.toLowerCase() > b.uniqueDisplayName.toLowerCase()) return 1;
              return 0;
            });

            var items = {
              edit: _react2.default.createElement(
                'span',
                { key: 'edit', onClick: handleEdit },
                'Edit ',
                contentModel.uniqueDisplayName
              ),
              replace: _react2.default.createElement(
                'div',
                { key: 'replace' },
                'Replace with: ',
                _react2.default.createElement(
                  'select',
                  { value: contentModel.id, onChange: handleReplace },
                  _react2.default.createElement('option', null),
                  filteredEnts.map(function (cm) {
                    return _react2.default.createElement(
                      'option',
                      { key: cm.id, value: cm.id },
                      cm.uniqueDisplayName
                    );
                  })
                )
              ),
              remove: _react2.default.createElement(
                'span',
                { key: 'remove', onClick: handleRemove },
                'Remove ',
                contentModel.uniqueDisplayName
              ),
              moveup: contentModelIndex !== 0 ? _react2.default.createElement(
                'span',
                { key: 'moveup', onClick: handleMoveUp },
                'Move up'
              ) : false,
              movedown: contentModelIndex !== parentArray.length - 1 ? _react2.default.createElement(
                'span',
                { key: 'movedown', onClick: handleMoveDown },
                'Move down'
              ) : false
            };
            if (!filteredEnts.length) delete items.replace;
            if (editorViewStore.contentModel === contentModel || editorViewStore.lastCm && editorViewStore.lastCm.length && editorViewStore.lastCm[0] && editorViewStore.lastCm[0] === contentModel || contentModel.readonly) delete items.edit;
            return items;
          });

          editableIcons.push(_react2.default.createElement('span', {
            key: 'editIcon',
            className: 'editable-icon',
            onClick: function onClick(e) {
              openContextMenu(e, menuItems, editorViewStore);
            } }));
        }
      } else {
        console.warn("fell through..." + contentModel.id + accessor);
      }
      break;
    case 3:
      // @TODO!!!
      // combined mode:

      // data-editable={[contentModel, "accessorToCM", "accessorToArray"]}
      // context menu allows directly on sub-model: direct edit, replace, replace with new, add new
      // pencils -> context menu allows on array items: direct edit, replace, create new, move up, move down
      // NOTE: when iterating, your element key must be the contentModel id
      // For ex: {array.map( item => <div key={item.id}></div> )}
      break;
  }

  if (editableIcons.length) changes.children = editableIcons;

  return finalizeElement(element, editorViewStore, changes, cmAccessorMode ? null : dataEditable, noChildren);
}

function simboxEditable(componentClass) {
  var _dec, _class;

  if (!componentClass.isMobXReactObserver) {
    var err = new Error();
    return err.stack;
    console.warn("Please ensure @editable decorator is placed before @observer, otherwise you may experience unpredictable results!");
    console.warn(err.stack);
  }

  var SimboxEditable = (_dec = (0, _mobxReact.inject)("editorViewStore"), _dec(_class = function (_componentClass) {
    (0, _inherits3.default)(SimboxEditable, _componentClass);

    function SimboxEditable() {
      (0, _classCallCheck3.default)(this, SimboxEditable);
      return (0, _possibleConstructorReturn3.default)(this, (SimboxEditable.__proto__ || (0, _getPrototypeOf2.default)(SimboxEditable)).apply(this, arguments));
    }

    (0, _createClass3.default)(SimboxEditable, [{
      key: 'render',
      value: function render() {
        var editorViewStore = this.props.editorViewStore;

        // if in simulation view for ex. just return normal rendered component!

        if (!editorViewStore) return (0, _get3.default)(SimboxEditable.prototype.__proto__ || (0, _getPrototypeOf2.default)(SimboxEditable.prototype), 'render', this).call(this);

        var transfer = {};
        if (this.props["data-editable"]) transfer["data-editable"] = this.props["data-editable"];
        if (this.props["data-editable-key"]) transfer["data-editable-key"] = this.props["data-editable-key"];
        if (this.props["data-editable-transfer"]) transfer["data-editable-transfer"] = this.props["data-editable-transfer"];
        return transform((0, _keys2.default)(transfer).length > 0 ? (0, _react.cloneElement)((0, _get3.default)(SimboxEditable.prototype.__proto__ || (0, _getPrototypeOf2.default)(SimboxEditable.prototype), 'render', this).call(this), transfer) : (0, _get3.default)(SimboxEditable.prototype.__proto__ || (0, _getPrototypeOf2.default)(SimboxEditable.prototype), 'render', this).call(this), editorViewStore);
      }
    }]);
    return SimboxEditable;
  }(componentClass)) || _class);

  // for some reason losing statics when injecting

  (0, _keys2.default)(componentClass).forEach(function (k) {
    return !SimboxEditable.hasOwnProperty(k) && (SimboxEditable[k] = componentClass[k]);
  });

  SimboxEditable.wrappedComponent = componentClass;

  return SimboxEditable;
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getRandomIntInclusive, 'getRandomIntInclusive', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(transformElement, 'transformElement', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(finalizeElement, 'finalizeElement', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(openContextMenu, 'openContextMenu', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(transform, 'transform', 'src/core_modules/simbox-editable/decorator.js');

  __REACT_HOT_LOADER__.register(simboxEditable, 'simboxEditable', 'src/core_modules/simbox-editable/decorator.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/simbox-editable/decorator.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/decorator.js
// module chunks = 0